<script lang="ts">
  import Calculator from '#lib/components/calculator/Calculator.svelte';
</script>

<svelte:head>
  <title>Coffee Pal - Calculator</title>
</svelte:head>

<Calculator />
